import React, { createContext, useState, useContext, useEffect } from 'react';

interface TTSContextType {
    ttsEnabled: boolean;
    toggleTTS: () => void;
}

const TTSContext = createContext<TTSContextType>({
    ttsEnabled: true,
    toggleTTS: () => { },
});

export const useTTS = () => useContext(TTSContext);

export const TTSProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    // Initialize from localStorage or default to true
    const [ttsEnabled, setTTSEnabled] = useState<boolean>(() => {
        const saved = localStorage.getItem('ttsEnabled');
        return saved !== null ? JSON.parse(saved) : true;
    });

    // Save to localStorage whenever the value changes
    useEffect(() => {
        localStorage.setItem('ttsEnabled', JSON.stringify(ttsEnabled));
    }, [ttsEnabled]);

    const toggleTTS = () => {
        setTTSEnabled(prevState => !prevState);
    };

    return (
        <TTSContext.Provider value={{ ttsEnabled, toggleTTS }}>
            {children}
        </TTSContext.Provider>
    );
};
